import { supabase } from "../supabase";
import type { Aircraft } from "../types";

interface AircraftRow {
  id: string;
  school_id: string;
  tail: string;
  model: string;
  icon: string | null;
  state: "available" | "maintenance" | "dispatched";
  maintenance_due_days: number;
}

function mapAircraft(r: AircraftRow): Aircraft {
  return {
    id: r.id,
    schoolId: r.school_id,
    tail: r.tail,
    model: r.model,
    icon: r.icon ?? "",
    state: r.state,
    maintenanceDueDays: r.maintenance_due_days,
  };
}

export async function listBySchool(schoolId: string): Promise<Aircraft[]> {
  const { data, error } = await supabase
    .from("aircraft")
    .select("id, school_id, tail, model, icon, state, maintenance_due_days")
    .eq("school_id", schoolId)
    .order("tail", { ascending: true });
  if (error) throw error;
  return (data as AircraftRow[]).map(mapAircraft);
}
